import React, { Component } from "react";

class Short extends Component {
  render() {
    return (
      <div className='card m-1'>
        <div className='card-body'>
          <div className='embed-responsive embed-responsive-9by16'>
            <iframe
              className='embed-responsive-item'
              width='100%'
              height='100%'
              title={this.props.short.title}
              src={this.props.short.link}
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    );
  }
}

export default Short;
